import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.r6u_1 = partyId;
        this.s6u_1 = name;
        this.t6u_1 = email;
        this.u6u_1 = pairingRule;
        this.v6u_1 = badgesEnabled;
        this.w6u_1 = defaultBadgeName;
        this.x6u_1 = alternateBadgeName;
        this.y6u_1 = callSignsEnabled;
        this.z6u_1 = animationsEnabled;
        this.a6v_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.r6u_1.toString() + ', name=' + toString(this.s6u_1) + ', email=' + toString(this.t6u_1) + ', pairingRule=' + toString(this.u6u_1) + ', badgesEnabled=' + toString(this.v6u_1) + ', defaultBadgeName=' + toString(this.w6u_1) + ', alternateBadgeName=' + toString(this.x6u_1) + ', callSignsEnabled=' + toString(this.y6u_1) + ', animationsEnabled=' + toString(this.z6u_1) + ', animationSpeed=' + toString(this.a6v_1) + ')';
      }
      hashCode() {
        var result = this.r6u_1.hashCode();
        result = imul(result, 31) + hashCode(this.s6u_1) | 0;
        result = imul(result, 31) + hashCode(this.t6u_1) | 0;
        result = imul(result, 31) + hashCode(this.u6u_1) | 0;
        result = imul(result, 31) + hashCode(this.v6u_1) | 0;
        result = imul(result, 31) + hashCode(this.w6u_1) | 0;
        result = imul(result, 31) + hashCode(this.x6u_1) | 0;
        result = imul(result, 31) + hashCode(this.y6u_1) | 0;
        result = imul(result, 31) + hashCode(this.z6u_1) | 0;
        result = imul(result, 31) + hashCode(this.a6v_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.r6u_1.equals(other.r6u_1))
          return false;
        if (!equals(this.s6u_1, other.s6u_1))
          return false;
        if (!equals(this.t6u_1, other.t6u_1))
          return false;
        if (!equals(this.u6u_1, other.u6u_1))
          return false;
        if (!equals(this.v6u_1, other.v6u_1))
          return false;
        if (!equals(this.w6u_1, other.w6u_1))
          return false;
        if (!equals(this.x6u_1, other.x6u_1))
          return false;
        if (!equals(this.y6u_1, other.y6u_1))
          return false;
        if (!equals(this.z6u_1, other.z6u_1))
          return false;
        if (!equals(this.a6v_1, other.a6v_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
